import React from "react"

export default function Blog022() {
  return (
    <section>
    <article>
    <h2>22. 10-25-2022</h2>
          <h3>LESS</h3>
          <p>
          <strong>Hello!</strong>
          <br />
          It is almost halloween, and I am getting excited! My family decorated for halloween this year, 
          we even have a halloween tree. I enjoy the holidays, but I could do without the winter weather. 
          <br />
          <br />
          I have started implementing LESS, and I can see some pros and cons.
          <br />
          </p>
          <ul>
          Pros:
          <li> The page will load slightly faster</li>
          <li>You may store variables, making it easy to change multiple items</li>
          <li>Variables and mix-ins clean up the HTML</li>
          
          </ul>
          <ul>
          Cons:
          <li> The file must be compiled before deployment</li>
          <li>Not everyone can read LESS, less user compatibility </li>
          </ul>
         <br />
         <p>
          My LESS conclusion, I have added LESS to my skills, but I prefer CSS for my own projects 
          at the moment. I am happy I took the time to learn it for when the time comes I must edit a 
          pre-existing LESS project. 
         <br />
         <br />
     </p>
     <h3>Occupation</h3>
     <p>
         <br />
         I have been working hard on creating and improving my website and portfolio. I updated my 
         website last week, I talk about it in the last blog post. This week I have been updating portions
          of that website that are linked with iframes. <br />
          The Resume on my website is my primary resume. The same resume I have saved as a pdf file and 
          uploaded to websites like Indeed and Glassdoor. I designed this resume with Bootstrap and secured 
          it with Netlify. <br />
          The Portfolio section is also a bootstrap website, with some simple but responsive design. You honestly
           don't get to see the responsiveness, as the iframe import max screen width is 600px. 
         <br /><br />
         With my website updated to an appropriate level of impression, I am now actively seeking occupation in the software development field. 
         My contact information is on my website! Thanks for reading!
         <br /><br />
          ~ Eric Polley
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
